import React from "react";

const InfoItem = ({
  icon: Icon,
  label,
  value,
  href,
}) => {
  const Wrapper = href ? "a" : "div";

  return (
    <Wrapper
      {...(href
        ? {
            href,
            target: "_blank",
            rel: "noreferrer",
          }
        : {})}
      className="flex items-start gap-4"
    >
      <span className="inline-flex size-12 items-center justify-center">
        <Icon className="text-primary text-sm" />
      </span>

      <div>
        <p className="text-xs text-gray-400">
          {label}
        </p>

        <p className="text-sm font-semibold">
          {value}
        </p>
      </div>
    </Wrapper>
  );
};

export default InfoItem;